import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CarouselModule } from 'ngx-owl-carousel-o';

import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

import { HeaderComponent } from './common/components/layout/header/header.component';
import { FooterComponent } from './common/components/layout/footer/footer.component';
import { DialogConfirmComponent } from './common/components/dialogs/dialog-confirm/dialog-confirm.component';
import { DialogErrorComponent } from './common/components/dialogs/dialog-error/dialog-error.component';
import { DialogSuccessComponent } from './common/components/dialogs/dialog-success/dialog-success.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './shared/services/common/interceptors/loader.interceptor';
import { OpenTradingAccountComponent } from './landing-pages/open-trading-account/open-trading-account.component';
import { OpenTradingAccount1Component } from './landing-pages/open-trading-account1/open-trading-account1.component';
import { OpenTradingAccount2Component } from './landing-pages/open-trading-account2/open-trading-account2.component';
import { OpenTradingAccount3Component } from './landing-pages/open-trading-account3/open-trading-account3.component';
import { OpenTradingAccount4Component } from './landing-pages/open-trading-account4/open-trading-account4.component';
import { OpenTradingAccount5Component } from './landing-pages/open-trading-account5/open-trading-account5.component';
import { OpenTradingAccount7Component } from './landing-pages/open-trading-account7/open-trading-account7.component';
import { OpenTradingAccount8Component } from './landing-pages/open-trading-account8/open-trading-account8.component';
import { GpayComponent } from './landing-pages/gpay/gpay.component';
import { PhonepeComponent } from './landing-pages/phonepe/phonepe.component';
import { OpenTradingAccount9Component } from './landing-pages/open-trading-account9/open-trading-account9.component';
import { OpenTradingAccount10Component } from './landing-pages/open-trading-account10/open-trading-account10.component';
import { OpenTradingAccount11Component } from './landing-pages/open-trading-account11/open-trading-account11.component';
import { OpenTradingAccount12Component } from './landing-pages/open-trading-account12/open-trading-account12.component';
import { OpenTradingAccount13Component } from './landing-pages/open-trading-account13/open-trading-account13.component';
import { OpenTradingAccount14Component } from './landing-pages/open-trading-account14/open-trading-account14.component';
import { OpenTradingAccount15Component } from './landing-pages/open-trading-account15/open-trading-account15.component';
import { OpenTradingAccount16Component } from './landing-pages/open-trading-account16/open-trading-account16.component';
import { OpenTradingAccount17Component } from './landing-pages/open-trading-account17/open-trading-account17.component';
import { OpenTradingAccount18Component } from './landing-pages/open-trading-account18/open-trading-account18.component';
import { OpenTradingAccount19Component } from './landing-pages/open-trading-account19/open-trading-account19.component';
import { OpenTradingAccount2in1_1Component } from './landing-pages/open-trading-account2in1_1/open-trading-account2in1_1.component';
import { CredComponent } from './landing-pages/cred/cred.component';
import { OpenTradingAccount20Component } from './landing-pages/open-trading-account20/open-trading-account20.component';
import { OpenTradingAccount21Component } from './landing-pages/open-trading-account21/open-trading-account21.component';
import { TokenInterceptor } from './shared/services/common/interceptors/token.interceptor';
import { ThankYouComponent } from './landing-pages/thank-you/thank-you.component';
import { NgwWowModule } from 'ngx-wow';
import { EquitasComponent } from './landing-pages/equitas/equitas.component';

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		DialogConfirmComponent,
		DialogErrorComponent,
		DialogSuccessComponent,
		OpenTradingAccountComponent,
		OpenTradingAccount1Component,
		OpenTradingAccount2Component,
		OpenTradingAccount3Component,
		OpenTradingAccount4Component,
		OpenTradingAccount5Component,
		//OpenTradingAccount6Component,
		OpenTradingAccount7Component,
		//CplComponent,
		OpenTradingAccount8Component,
		GpayComponent,
		PhonepeComponent,
		OpenTradingAccount9Component,
		OpenTradingAccount10Component,
		OpenTradingAccount11Component,
		OpenTradingAccount12Component,
		OpenTradingAccount13Component,
		OpenTradingAccount14Component,
		OpenTradingAccount15Component,
		OpenTradingAccount16Component,
		OpenTradingAccount17Component,
		OpenTradingAccount18Component,
		OpenTradingAccount19Component,
		CredComponent,
		OpenTradingAccount20Component,
		OpenTradingAccount2in1_1Component,
		ThankYouComponent,
		//MegaTradingDaysComponent,
		//MegaTradingDays1Component,
		EquitasComponent,
		OpenTradingAccount21Component
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		NgbModule,
		CarouselModule,
		NgSelectModule,
		FormsModule,
		NgwWowModule,
		HttpClientModule
	],
	exports: [
		FormsModule,
		NgbModule
	],
	providers: [
		//{
		//	provide: LocationStrategy,
		//	useClass: HashLocationStrategy
		//},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: LoaderInterceptor,
			multi: true
		}
	],
	bootstrap: [AppComponent]
})
export class AppModule { }
